import {Graph, Node} from "../../../model/Graph";

export const isDisconnected = (node: Node): boolean => {
  return node.getTags().contains(ispConst.TAG_DISCONNECTED);
}

export const markAsDisconnected = (node: Node, graph: Graph): Node => {
  if(isDisconnected(node)) {
    return node;
  }

  const changedTags = node.getTags().push(ispConst.TAG_DISCONNECTED);

  graph.changeNodeTags(node, changedTags);

  return graph.getNode(node.getId()) as Node;
}

